<template>
  <div :class="borderTopClass" class="phaneroo-notification max-w-sm text-left border-t-4 w-full bg-white shadow-lg rounded-md pointer-events-auto">
    <div class="rounded-lg shadow-xs overflow-hidden">
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <b-icon :class="iconColor" class="h-6 w-6" :icon="iconName" />
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-md font-bold leading-5 font-medium text-gray-900">
              <slot name="title" />
            </p>
            <p class="mt-1 text-sm leading-5 text-gray-700">
              <slot />
            </p>
          </div>
          <div class="ml-4 flex-shrink-0 flex">
            <button @click="onClose" class="inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150">
              <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Still a WIP.
 * Will updgrade after MVP to support actions.
 */
export default {
  name: 'Notification',
  props: {
    type: {
      type: String,
      default: 'info',
      validator (value) {
        return ['info', 'success', 'warning', 'error'].includes(value)
      }
    },
    actions: {
      type: Array,
      default: () => ([])
    },
    onClose: {
      type: Function,
      default: () => null
    }
  },
  computed: {
    iconName () {
      switch (this.type) {
        case 'info':
          return 'info-circle'
        case 'success':
          return 'check-circle'
        case 'warning':
          return 'exclamation-triangle'
        case 'error':
          return 'exclamation-circle'
        default:
          return 'info-circle'
      }
    },
    borderTopClass () {
      switch (this.type) {
        case 'info':
          return 'border-blue-400'
        case 'success':
          return 'border-green-500'
        case 'warning':
          return 'border-orange-500'
        case 'error':
          return 'border-red-500'
        default:
          return 'border-blue-600'
      }
    },
    iconColor () {
      switch (this.type) {
        case 'info':
          return 'text-blue-400'
        case 'success':
          return 'text-green-500'
        case 'warning':
          return 'text-orange-500'
        case 'error':
          return 'text-red-500'
        default:
          return 'text-blue-600'
      }
    }
  }
}
</script>
